module.exports = __webpack_public_path__ + "img/trace-car.ee8f8970.png";